export default "__VITE_ASSET__C8H0yhaR__"